<p-autoComplete
  (completeMethod)='searchCategory($event)'
  (onSelect)='onAddCategory($event)'
  (onUnselect)='onRemoveCategory($event)'
  [(ngModel)]='selectedCategories'
  [disabled]='disabled'
  [forceSelection]='true'
  [multiple]='multipleCategories'
  [placeholder]='placeholder'
  [suggestions]='categorySearchResults$ | async'
  field='name'
  id='categories'
></p-autoComplete>
